
import request from "@/CommonDP/utils/request";
// 文档模块接口
export default {
    batchDownloadFolder(params, cb) {
        return this.useProcessRequest(
            "/new/file/download/folderBatch",
            params,
            cb
        );
    },
    useProcessRequest(url, params, cb) {
        let randomNum = Math.ceil(Math.random() * 10);
        let times = 1;
        return request({
            responseType: "blob",
            url: url,
            method: "post",
            data: params,
            onDownloadProgress: function (progressEvent) {
                times += 1;
                if (progressEvent.lengthComputable) {
                    typeof cb === "function" &&
                        cb((progressEvent.loaded / progressEvent.total) * 100);
                } else {
                    if (times % 4 === 0)
                        randomNum =
                            Math.ceil(times / 4) * randomNum > 90
                                ? randomNum
                                : Math.ceil(times / 4) * randomNum;
                    typeof cb === "function" && cb(randomNum);
                }
            },
        });
    },
}